import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Sale } from '../../models/sale/sale.model';
import { SaleService } from '../../services/sale.service';
import { List } from 'immutable';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-register-closure-sales',
  templateUrl: './register-closure-sales.page.html',
  styleUrls: ['./register-closure-sales.page.scss'],
})
export class RegisterClosureSalesPage implements OnInit {

  public sales: List<Sale>;

  public isLoading: boolean;

  public errorOccuredWhileLoadingSales: boolean;

  public paymentType: number;

  public startDate: Date;

  public endDate: Date;

  constructor (private changeDetectorRef: ChangeDetectorRef,
              private saleService: SaleService,
              private route: ActivatedRoute

              ) {
    this.sales = List([]);

    /* this.route.params.subscribe(params => {
    }); */

    this.paymentType = route.snapshot.params.paymentType;
    this.startDate   = route.snapshot.params.startDate;
    this.endDate     = route.snapshot.params.endDate;

    //this.paymentType = this.navParams.get('paymentType');
    //this.startDate = this.navParams.get('startDate');
    //this.endDate = this.navParams.get('endDate');
  }

  public ngOnInit ( ){
    this.loadSales();
  }

  public loadSales () {
    this.isLoading = true;
    this.errorOccuredWhileLoadingSales = false;
    this.saleService.loadSalonSalesByPaymentType(this.startDate, this.endDate, List([this.paymentType]))
      .subscribe({
        next:(result) => {
        this.isLoading = false;
        this.sales = result;
        this.changeDetectorRef.markForCheck();
      },
      error: (e) => {
        this.isLoading = false;
        this.errorOccuredWhileLoadingSales = true;
        this.changeDetectorRef.markForCheck();
      }
    });
  }

}
